import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M50.0004 65.1379H49.9999C47.9047 65.1379 45.9369 64.3156 44.4593 62.8224L23.204 41.3337C21.7279 39.8415 21.7411 37.4357 23.2333 35.9597C24.725 34.4846 27.1312 34.4973 28.6073 35.989L49.8627 57.4777C49.8905 57.506 49.932 57.5383 50.0004 57.5383C50.0692 57.5383 50.1107 57.5051 50.139 57.4767L71.3939 35.989C72.8705 34.4973 75.2767 34.4841 76.767 35.9597C78.2592 37.4357 78.2728 39.8415 76.7963 41.3337L55.5414 62.8215C54.0638 64.3156 52.0961 65.1379 50.0004 65.1379Z'

const IconCaretDown: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCaretDown
